<template>
  <div class="student">
    <van-nav-bar
      title="选择学生"
      left-text="返回"
      left-arrow
      @click-left="$router.go('-1')"
    />
    <van-cell-group inset style="margin-top:10px">
      <van-field
        readonly
        clickable
        name="area"
        :value="areavalue"
        label="地区选择"
        placeholder="点击选择省市区"
        @click="showArea = true"
      />
     
      <van-popup v-model="showArea" position="bottom">
        <van-area
          :area-list="areaList"
          @confirm="onAreaConfirm"
          @cancel="showArea = false"
        />
      </van-popup>
      <van-field
        v-model="schoolValue"
        is-link
        readonly
        label="选择学校"
        placeholder="请选择所在学校"
        @click="showSchool = true"
      />
       <van-popup v-model="showSchool" position="bottom">
        <van-cascader
          v-model="cascaderValue"
          title="请选择所在学校"
          :options="schoolList"
          :field-names="schoolFieldNames"
          @close="showSchool = false"
          @finish="onSchoolFinish"
        />
      </van-popup>
      <van-field
        v-model="gradeValue"
        is-link
        readonly
        label="年级班级"
        placeholder="请选择年级班级"
        @click="showGrade = true"
      />
       <van-popup v-model="showGrade" position="bottom">
        <van-cascader
          v-model="cascaderValue"
          title="请选择年级班级"
          :options="gradeList"
          :field-names="gradeFieldNames"
          @close="showGrade = false"
          @finish="onGradeFinish"
        />
      </van-popup>
      <van-field
        v-model="studentinfo.studentname"
        name="学生姓名"
        label="学生姓名"
        placeholder="学生姓名"
        :rules="[{ required: true, message: '请填写学生姓名' }]"
      />
      <van-field label="性别">
        <template #input>
        <van-radio-group v-model="studentinfo.sex"  direction="horizontal">
        <van-radio name="男" >男</van-radio>
        <van-radio name="女" >女</van-radio>
        </van-radio-group>
        </template>

      </van-field>
      <van-field label="走读/寄宿">
        <template #input>
        <van-radio-group v-model="studentinfo.studenttype"  direction="horizontal">
        <van-radio name="1" >走读</van-radio>
        <van-radio name="2" >寄宿</van-radio>
        </van-radio-group>
        </template>

      </van-field>
    </van-cell-group>

    <div style="margin: 16px;">
    <van-button round block type="info" native-type="submit" @click="nextFamily">下一步</van-button>
      </div>
  </div>
</template>

<script>
import { NavBar, Cell,Area, CellGroup,Button, Field,Cascader,RadioGroup, Radio,Toast   } from 'vant'
import { areaList } from '@vant/area-data';

export default {
  data() {
    return {
      areavalue: '',
      showArea: false,
      showSchool:false,
      showGrade:false,
      schoolValue:'',
      gradeValue:'',
      cascaderValue:'',
      sexRadio:1,
      areaList, // 数据格式见 Area 组件文档
      studentinfo:{
        provicecode:"",
        citycode:"",
        districtcode:"",
        schoolid:0,
        gradeid:0,
        classid:0,
        studentname:"",
        sex:"",
        studenttype:0,
        studentid:0,
        ismaster:0
      },
      schoolFieldNames:{
        text: 'Schoolname',
        value: 'Schoolid',
        children: 'items',
      },
      gradeFieldNames:{
        text: 'name',
        value: 'code',
        children: 'Classlist',
      },
      schoolList:[
      ],
      gradeList:[]
      
    }
  },
  created() {
   
  },
  
  methods: {
    nextFamily:function(){
      console.log("studentinfo",this.studentinfo);
      
      this.$http
        .json_post(this.$api.baseinfo.checkstudent, {
          schoolid : eval(this.studentinfo.schoolid),
          gradeid : eval(this.studentinfo.gradeid),
          classid : eval(this.studentinfo.classid),
          studentname : this.studentinfo.studentname
        })
        .then(data => {
          console.log("data",data);
          if (data.code===0){
            if (data.data.Resultcode===0){
              Toast.fail('平台没有找到该学生');
              return;
            }
            this.studentinfo.studentid=data.data.Studentid;
            localStorage.setItem("bindStudentinfo",JSON.stringify(this.studentinfo));
            localStorage.setItem("curDistrictCode", this.studentinfo.districtcode)
            if (data.data.Resultcode == 2) {
              this.studentinfo.ismaster = 1;
             
              var addgurad ={
                addFlag:1
              }
              localStorage.setItem("addGuardianFalg",JSON.stringify(addgurad))
              this.$router.push('/familyinfo');
            }
            if (data.data.Resultcode ==1 ){
              this.studentinfo.ismaster = 0;
              if (this.$route.query.bindother != 1) {
                var addgurad = {
                addFlag:0
                }
                localStorage.setItem("addGuardianFalg",JSON.stringify(addgurad))
                this.$router.push('/familybind');
              } else {
                this.$router.push({name:'familyinfo', query: {bindother:1}});
              }
              
            }
          }else {
            localStorage.removeItem("addGuardianFalg")
            localStorage.removeItem("bindStudentinfo")
            Toast.fail(data.msg);
          }
        })
      
    },
    onAreaConfirm:function(values){
      this.showArea=false;
      console.log(values);
      this.areavalue=values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join('/');
      if(values.length==3){
        this.studentinfo.provicecode=values[0].code;
        this.studentinfo.citycode=values[1].code;
        this.studentinfo.districtcode=values[2].code;
        this.getschoollist();
      }
    },
    onSchoolFinish:function(values){
      console.log(values);
     // console.log(values.selectedOptions[0].value,values.selectedOptions[0].text);
      this.schoolValue = values.selectedOptions[0].Schoolname;
      this.studentinfo.schoolid = values.selectedOptions[0].Schoolid;
      this.showSchool =false;
      this.getgradeclass();
    },
    onGradeFinish:function(values){
      console.log(values);
      if(values.selectedOptions.length==2){
        this.studentinfo.gradeid = values.selectedOptions[0].code;
        this.studentinfo.classid = values.selectedOptions[1].code;
        this.gradeValue = values.selectedOptions[0].name +'('+ values.selectedOptions[1].name +')';
        this.showGrade =false;
      }
    },
    getschoollist:function(){
      this.schoolList=[];
      this.schoolValue='';
      this.gradeValue=''
      this.studentinfo.schoolid=0;
      this.studentinfo.gradeid=0;
      this.studentinfo.classid=0;
      this.studentinfo.studentname='';

      this.$http
        .json_post(this.$api.baseinfo.getschoollist, {
          provicecode: this.studentinfo.provicecode,
          citycode:this.studentinfo.citycode,
          districtcode:this.studentinfo.districtcode
        })
        .then(data => {
          console.log("data",data);
          if (data.code===0){
            this.schoolList=data.data;
          }else {
          }
        })
    },
    getgradeclass:function(){
      this.$http
        .json_post(this.$api.baseinfo.getgradeclass, {
          schoolid : eval(this.studentinfo.schoolid)
        })
        .then(data => {
          console.log("data",data);
          if (data.code===0){
            this.gradeList=data.data;
          }else {
          }
        })
    }

  },
  components: {
    'van-nav-bar': NavBar,
    'van-cell-group': CellGroup,
    'van-cell': Cell,
    'van-area': Area,
    'van-field':Field,
    'van-cascader':Cascader ,
    'van-radio-group':RadioGroup,
    'van-radio':Radio,
    'van-button':Button
  }
}
</script>

<style lang="scss" scoped>
.icon-xuesheng {
  color: $primary-color;
}
</style>
